var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDiscussionsByTeachersWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 133.059,
    height: 133,
    viewBox: "0 0 133.059 133",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.055,
    y1: -0.766,
    x2: 1.636,
    y2: 1.056,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#098caf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09d785"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2368",
    "data-name": "Caminho 2368",
    d: "M26.128,87.113h7.816c-.366,2.323-2,4.227-3.768,4.313q-.065,0-.13,0c-1.746,0-3.359-1.715-3.918-4.316m10.12,5.13a18.671,18.671,0,0,0,2.063-4.875c.247-.75.383-1.185,1.278-1.373a32.506,32.506,0,0,0,16.662-9.136q9.113-9.181,18.3-18.295c2.441-2.429,6.047-1.6,6.862,1.547A3.883,3.883,0,0,1,80.185,64q-3.126,3.131-6.253,6.259-12.894,12.889-25.8,25.764a9.732,9.732,0,0,0-3.092,7.4c.076,7.372.025,14.744.025,22.227H15.066V100.082H10.759v25.582h-6.4c-.023-.382-.069-.77-.069-1.157,0-5.987-.019-11.974,0-17.963a19.327,19.327,0,0,1,15.438-19c.6-.128,1.214-.16,1.568-.2a36.21,36.21,0,0,0,2.562,5,7.672,7.672,0,0,0,6.179,3.414,7.6,7.6,0,0,0,6.207-3.506m-6.377-9.395a12.873,12.873,0,1,1,.141,0h-.141M71.527,55.5q-9.338,9.338-18.678,18.673a28.217,28.217,0,0,1-9,6.047c2.822-4.256,3.944-8.556,3.082-13.254A16.773,16.773,0,0,0,39.57,55.736a17.052,17.052,0,0,0-21.827,2.3,16.67,16.67,0,0,0-4.824,10.774c-.358,5.763,1.838,10.52,6.181,14.463-.393.093-.6.135-.8.19C6.891,86.488,0,95.462,0,107.294q0,2.664,0,5.328v17.4H49.35v-1.568c0-8.312.035-16.624-.025-24.934a5.872,5.872,0,0,1,1.889-4.506q15.735-15.645,31.4-31.364a16.817,16.817,0,0,0,1.539-1.675,8.179,8.179,0,0,0-4.042-12.753,8.819,8.819,0,0,0-2.634-.423,8.292,8.292,0,0,0-5.945,2.7",
    transform: "translate(0 -52.801)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2369",
    "data-name": "Caminho 2369",
    d: "M25.505,47.212c-3.3,0-4.962-1.648-4.964-4.924q0-10.118,0-20.234c0-3.172,1.705-4.874,4.875-4.875q18.362-.006,36.722,0h1.316c0,5.883.1,11.556-.033,17.225-.093,3.992.7,7.537,3.892,10.247a4.21,4.21,0,0,1-3.445,2.54,1.75,1.75,0,0,1-.535.019c-3.558-.584-6.479.706-9.205,2.892-1.694,1.36-3.613,2.443-5.618,3.776V47.214H36.227q-5.361,0-10.721,0m48.665-4.293a6.389,6.389,0,0,1-6.41-6.389q-.057-12.932,0-25.864a6.312,6.312,0,0,1,6.3-6.344q23.723-.051,47.447,0a6.305,6.305,0,0,1,6.3,6.35q.063,12.934,0,25.865a6.391,6.391,0,0,1-6.688,6.38q-9.717.017-19.435.007l-8.711,0H91.339v6.683a63.585,63.585,0,0,1-5.678-3.8,11.8,11.8,0,0,0-9.615-2.89,5.231,5.231,0,0,1-.717.043c-.386,0-.773-.027-1.158-.036M95.34,0q-10.6,0-21.2.027A10.554,10.554,0,0,0,63.671,8.836c-.227,1.263-.21,2.569-.321,4.05H61.712q-18.172,0-36.342,0c-5.468,0-9.108,3.611-9.117,9.042q-.017,10.257,0,20.515c.008,5.432,3.646,9.047,9.105,9.055q8.649.014,17.3,0h1.515V61.858c.521-.313.9-.521,1.256-.758,4.5-2.995,8.983-6.011,13.5-8.97a4.452,4.452,0,0,1,1.968-.6c.572-.052,1.15-.052,1.729-.052a14.85,14.85,0,0,0,2.149-.1,8.486,8.486,0,0,0,6.2-4.337c2.774.061,5.313.077,7.845.2a4.371,4.371,0,0,1,2.092.634c4.488,2.929,8.934,5.924,13.4,8.9.383.256.781.493,1.362.86V47.212h1.533c8.046,0,16.092.032,24.138-.012A10.639,10.639,0,0,0,132.1,36.616q.043-5.882.046-11.765V22.368q0-5.882-.046-11.764A10.6,10.6,0,0,0,121.476.032Q111.4,0,101.332,0Z",
    transform: "translate(-16.244 -0.001)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2370",
    "data-name": "Caminho 2370",
    d: "M97.045,109.484c1.105-4.32,2.291-8.619,3.508-12.909a12.429,12.429,0,0,1,12.312-9.425c6.346.1,11.954,5.15,12.121,11.487.236,8.97.059,17.949.059,27.025H97.271V121.41a19.229,19.229,0,0,0,2.793-.021,8.089,8.089,0,0,0,6.891-5.443c2.458-7.027,4.75-14.115,7.1-21.18a2.712,2.712,0,0,0,.035-.54L110.179,92.9c-1.405,4.2-2.761,8.252-4.118,12.3-.975,2.918-1.93,5.844-2.93,8.754a4.239,4.239,0,0,1-4.4,3.216q-12.935.021-25.87,0c-2.752-.006-4.407-2.5-3.173-4.72a3.465,3.465,0,0,1,3.38-1.722q4.724.016,9.447.011c4.269,0,8.536,0,12.8.025h.034c.994,0,1.427-.254,1.691-1.282M92.9,70.021a12.87,12.87,0,1,1,12.913,12.828h-.037A12.913,12.913,0,0,1,92.9,70.021m8.471-16.64A17.4,17.4,0,0,0,88.614,68.907c-.391,6.707,3.39,15.065,13.346,17.867-3.523,2.9-5.165,6.634-6.148,10.771-.709,2.98-1.6,5.918-2.427,8.907H91.808c-6.258,0-12.515-.02-18.772.02a9.846,9.846,0,0,0-3.021.451,7.471,7.471,0,0,0,2.377,14.529c4.432.036,8.865.029,13.3.022q2.871,0,5.744,0h1.5v8.491h36.35a3.552,3.552,0,0,0,.074-.472c0-10.189.07-20.38-.037-30.569A16.52,16.52,0,0,0,118.4,83.914c-.536-.2-1.074-.385-1.75-.626a17.621,17.621,0,0,0,6.041-10.559A16.645,16.645,0,0,0,120.249,60.8a17.117,17.117,0,0,0-14.489-7.989,17.4,17.4,0,0,0-4.394.566",
    transform: "translate(-64.979 -52.814)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2307",
    "data-name": "Ret\\xE2ngulo 2307",
    width: 51.373,
    height: 4.125,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2309",
    "data-name": "Ret\\xE2ngulo 2309",
    width: 51.374,
    height: 4.122,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2311",
    "data-name": "Ret\\xE2ngulo 2311",
    width: 42.742,
    height: 4.136,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2313",
    "data-name": "Ret\\xE2ngulo 2313",
    width: 34.207,
    height: 4.122,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2315",
    "data-name": "Ret\\xE2ngulo 2315",
    width: 4.172,
    height: 4.114,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2317",
    "data-name": "Ret\\xE2ngulo 2317",
    width: 4.077,
    height: 4.171,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2319",
    "data-name": "Ret\\xE2ngulo 2319",
    width: 4.172,
    height: 4.106,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2321",
    "data-name": "Ret\\xE2ngulo 2321",
    width: 34.16,
    height: 4.131,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2323",
    "data-name": "Ret\\xE2ngulo 2323",
    width: 34.159,
    height: 4.126,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2325",
    "data-name": "Ret\\xE2ngulo 2325",
    width: 25.578,
    height: 4.134,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2327",
    "data-name": "Ret\\xE2ngulo 2327",
    width: 4.123,
    height: 4.146,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-discussions-by-teachers-white",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5022",
    "data-name": "Grupo 5022",
    transform: "translate(0 55.779)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5021",
    "data-name": "Grupo 5021",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2303",
    "data-name": "Ret\\xE2ngulo 2303",
    width: 87.568,
    height: 78.936,
    transform: "translate(0 -1.715)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5024",
    "data-name": "Grupo 5024",
    transform: "translate(17.16 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5023",
    "data-name": "Grupo 5023",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2304",
    "data-name": "Ret\\xE2ngulo 2304",
    width: 115.902,
    height: 61.857,
    transform: "translate(-0.003 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5026",
    "data-name": "Grupo 5026",
    transform: "translate(68.644 55.793)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5025",
    "data-name": "Grupo 5025",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2305",
    "data-name": "Ret\\xE2ngulo 2305",
    width: 64.92,
    height: 77.147,
    transform: "translate(-0.468 0)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5028",
    "data-name": "Grupo 5028",
    transform: "translate(73.017 25.853)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5027",
    "data-name": "Grupo 5027",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2306",
    "data-name": "Ret\\xE2ngulo 2306",
    width: 51.373,
    height: 4.125,
    transform: "translate(0 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5030",
    "data-name": "Grupo 5030",
    transform: "translate(73.013 34.413)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5029",
    "data-name": "Grupo 5029",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2308",
    "data-name": "Ret\\xE2ngulo 2308",
    width: 51.374,
    height: 4.122,
    transform: "translate(0 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5032",
    "data-name": "Grupo 5032",
    transform: "translate(73.061 17.266)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5031",
    "data-name": "Grupo 5031",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2310",
    "data-name": "Ret\\xE2ngulo 2310",
    width: 42.742,
    height: 4.136,
    transform: "translate(0 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5034",
    "data-name": "Grupo 5034",
    transform: "translate(90.185 8.691)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5033",
    "data-name": "Grupo 5033",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2312",
    "data-name": "Ret\\xE2ngulo 2312",
    width: 34.207,
    height: 4.122,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5036",
    "data-name": "Grupo 5036",
    transform: "translate(73.019 8.696)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5035",
    "data-name": "Grupo 5035",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2314",
    "data-name": "Ret\\xE2ngulo 2314",
    width: 4.172,
    height: 4.114,
    transform: "translate(0 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5038",
    "data-name": "Grupo 5038",
    transform: "translate(81.649 8.624)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5037",
    "data-name": "Grupo 5037",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2316",
    "data-name": "Ret\\xE2ngulo 2316",
    width: 4.077,
    height: 4.171,
    transform: "translate(0 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5040",
    "data-name": "Grupo 5040",
    transform: "translate(120.21 17.257)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5039",
    "data-name": "Grupo 5039",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2318",
    "data-name": "Ret\\xE2ngulo 2318",
    width: 4.172,
    height: 4.106,
    transform: "translate(0 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5042",
    "data-name": "Grupo 5042",
    transform: "translate(25.811 30.118)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5041",
    "data-name": "Grupo 5041",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2320",
    "data-name": "Ret\\xE2ngulo 2320",
    width: 34.16,
    height: 4.131,
    transform: "translate(0 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5044",
    "data-name": "Grupo 5044",
    transform: "translate(25.809 38.701)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5043",
    "data-name": "Grupo 5043",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2322",
    "data-name": "Ret\\xE2ngulo 2322",
    width: 34.159,
    height: 4.126,
    transform: "translate(0 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5046",
    "data-name": "Grupo 5046",
    transform: "translate(34.395 21.535)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5045",
    "data-name": "Grupo 5045",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2324",
    "data-name": "Ret\\xE2ngulo 2324",
    width: 25.578,
    height: 4.134,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5048",
    "data-name": "Grupo 5048",
    transform: "translate(25.845 21.552)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5047",
    "data-name": "Grupo 5047",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2326",
    "data-name": "Ret\\xE2ngulo 2326",
    width: 4.123,
    height: 4.146,
    transform: "translate(0 0)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDiscussionsByTeachersWhite);
export default __webpack_public_path__ + "static/media/icon-discussions-by-teachers-white.c1fb7042e9bd78d4c1e3dd3fb3ad99f5.svg";
export { ForwardRef as ReactComponent };